import { format } from 'date-fns'

export default {
    usersRanking: [],
    usersRankingLoading: false,
    rankingGroups: [],
    rankingTypes: [],
    usersRankingFilters: setInitialUsersRankingFilters(),
    setInitialUsersRankingFilters: setInitialUsersRankingFilters
}

function setInitialUsersRankingFilters() {
    return {
        type_id: 10, //Ogólny
        rankingGroup_id: null,
        startDateTime__lte: format(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'YYYY-MM-DD'),
        startDateTime__gte: null,
    }
}